const FEATURE_FLAGS = {
  COMPANY_EVENTS: "company-events",
};

export default FEATURE_FLAGS;
